export const GET_AUTH_REQUEST = 'GET_AUTH_REQUEST';
export const GET_AUTH_SUCCESS = 'GET_AUTH_SUCCESS';
export const GET_AUTH_FAILURE = 'GET_AUTH_FAILURE';
export const RESET_VALIDATION_MESSAGE = 'RESET_VALIDATION_MESSAGE';
